import { FC } from "react";
import { Path, Svg, SvgProps } from "react-native-svg";

const PdInfo: FC<SvgProps> = (props) => (
  <Svg viewBox="0 0 12 12" fill="none" {...props}>
    <Path
      d="M6.00003 0C4.40946 0.00224251 2.88453 0.635003 1.75977 1.75977C0.635004 2.88453 0.00226445 4.40943 0 6.00003C0.32927 13.9591 11.6709 13.9562 12 6.00003C11.9978 4.40946 11.365 2.88453 10.2402 1.75977C9.11547 0.635003 7.59057 0.00226445 5.99997 0H6.00003ZM6.41864 8.09302C6.41864 8.32425 6.23126 8.51163 6.00003 8.51163C5.7688 8.51163 5.58143 8.32425 5.58143 8.09302V5.46141C5.58143 5.23018 5.7688 5.04281 6.00003 5.04281C6.23126 5.04281 6.41864 5.23018 6.41864 5.46141V8.09302ZM6.29579 4.04635C6.16423 4.17181 5.967 4.19872 5.80667 4.11313C5.64621 4.02754 5.55888 3.84876 5.58977 3.66962C5.59563 3.64308 5.60298 3.61704 5.61207 3.5915C5.62291 3.56609 5.63599 3.54179 5.65119 3.51887C5.71648 3.4202 5.82063 3.3538 5.93761 3.33598C6.05472 3.31829 6.1737 3.35093 6.26538 3.42593C6.35695 3.50093 6.41252 3.61119 6.41838 3.72942C6.42423 3.84765 6.37963 3.96276 6.29578 4.04636L6.29579 4.04635Z"
      fill="currentColor"
    />
  </Svg>
);

export default PdInfo;
